export default __webpack_public_path__ + "static/media/knowledgebase.d1647167.svg";